import * as React from 'react';
import { AppBar, TitlePortal,ExportButton } from 'react-admin';
import {Box, useMediaQuery, Theme, Divider} from '@mui/material';

import Logo from './Logo';
import { AppBarToolbar } from './AppBarToolbar';



const CustomAppBar = () => {
    const isLargeEnough = useMediaQuery<Theme>(theme =>
        theme.breakpoints.up('sm')
    );
    return (
        <>
            <AppBar  alwaysOn={false} color="secondary" sx={{ menuButton: 'display:none', paddingTop: '10px', paddingBottom: '10px'}} toolbar={<AppBarToolbar sx={{ paddingTop: '30px' }}/>}>


            {isLargeEnough && <Logo />}
            {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
          
            
        </AppBar>
        <br/>
        </>
    );
};

export default CustomAppBar;
